module.exports = __webpack_public_path__ + "img/logo.f8fbcb45.png";